import React from 'react';

import './search.scss';

const Search = (props) => {
  return (
    <div className="search-wrapper">
        <div className="search-icon"></div>
        <input {...props} />
    </div>
)}

export default Search;
